export default {
  aiToolSupport: {
    getToken: '/aiToolSupport/getToken',
    getToolUseLogs: '/aiToolSupport/getToolUseLogs',
    sendAIMessage: '/aiToolSupport/sendAIMessage',
    correctMessage: '/aiToolSupport/correctMessage',
    getAIToolPrompt: '/aiToolSupport/getAIToolPrompt',
    questions:'/aiToolSupport/questions',
    usageCount:'/aiToolSupport/usageCount',
  }
}
